module.exports = "/assets/data/629e702c7c40e141039bc7348ef37b8a-CF47.data.json";